(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('twitterChannelService',
            ['$uibModal', '$state',
                function ($uibModal, $state) {

                    var fac = {
                        getTwitterConfig: getTwitterConfig,
                    };

                    return fac;

                    function getTwitterConfig() {
                        return $uibModal.open({
                            templateUrl: 'components/channels/twitter/templates/twitter.html',
                            size: 'md',
                            resolve: {
                                twitterData: ['$q', '$stateParams', 'twitterServices', function ($q, $stateParams, twitterServices) {
                                    return twitterServices.getTwitterDetails($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }]

                            },
                            controller: 'TwitterCtrl'
                        });
                    }

                }]);

})(window.angular);